let clientStoriesSearchForm = $('#client-stories-search-form');

if(clientStoriesSearchForm.length) {

    let currentPage = 1,
        sort = 'most-recent',
        regionSelect = $('#client-stories-search-region-dropdown'),
        stateSelect = $('#client-stories-search-state-dropdown'),
        typeSelect = $('#client-stories-search-type-dropdown'),
        brokerSelect = $('#client-stories-search-broker-dropdown'),
        resetButton = $('#client-stories-reset-search'),
        resultsOutput = $('#client-stories-results-output'),
        countOutput = $('#property-count-label'),
        sortOptions = $('.client-search-sort-button'),
        paginationContainer = $('#client-stories-pagination-container');

    clientStoriesSearchForm.on('submit', function (e) {
        e.preventDefault();

        searchClientStories(false);
    });

    regionSelect.on('change', function () {
        searchClientStories(false);
    });

    stateSelect.on('change', function () {
        searchClientStories(false);
    });

    typeSelect.on('change', function () {
        searchClientStories(false);
    });

    brokerSelect.on('change', function () {
        searchClientStories(false);
    });

    sortOptions.on('click', function () {
        sort = $(this).data('sort-type');
        searchClientStories(false);
    });

    $(document).on('click', '.client-story-pagination-item', function (e) {
        e.preventDefault();

        currentPage = $(this).data('page');

        searchClientStories(true);
    });

    function shouldShowResetButton() {
        if(regionSelect.val().length > 0 || stateSelect.val().length > 0 || typeSelect.val().length > 0 || brokerSelect.val().length > 0) {
            resetButton.removeClass('d-none');
        } else {
            resetButton.addClass('d-none');
        }
    }

    resetButton.on('click', function (e) {
        e.preventDefault();

        regionSelect.selectpicker('val', '');
        stateSelect.selectpicker('val', '');
        typeSelect.selectpicker('val', '');
        brokerSelect.selectpicker('val', '');

        searchClientStories();
    });

    function searchClientStories(returnToTop) {

        shouldShowResetButton();
        countOutput.html('Loading...');

        $.post("/wp/wp-admin/admin-ajax.php", {
            'action': 'search_client_stories',
            'page': currentPage,
            'sort': sort,
            'regions': regionSelect.val(),
            'states': stateSelect.val(),
            'types': typeSelect.val(),
            'brokers': brokerSelect.val(),
        }, function (response) {
            if(response.success) {

                resultsOutput.html(response.data.html);
                paginationContainer.html(response.data.pagination);

                countOutput.html(response.data.total_stories + ' Client ' + (response.data.total_stories === 1 ? 'Story' : 'Stories'));

                // if(response.data.prev_active) {
                //     eventsPrevPage.removeClass('disabled');
                // } else {
                //     eventsPrevPage.addClass('disabled');
                // }
                //
                // if(response.data.next_active) {
                //     eventsNextPage.removeClass('disabled');
                // } else {
                //     eventsNextPage.addClass('disabled');
                // }

                // scroll to top of eventsContainer
                if(returnToTop) {
                    $('html, body').animate({
                        scrollTop: resultsOutput.offset().top - 286
                    });
                }
            }

            // eventsContainer.removeClass('loading');
        });

    }

    searchClientStories(false);

}
